import { render } from "./DadosBancarios.vue?vue&type=template&id=3de6d3b8"
import script from "./DadosBancarios.vue?vue&type=script&lang=js"
export * from "./DadosBancarios.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__